import { render, staticRenderFns } from "./EntriesList.vue?vue&type=template&id=c8162cfc&scoped=true"
import script from "./EntriesList.vue?vue&type=script&lang=js"
export * from "./EntriesList.vue?vue&type=script&lang=js"
import style0 from "./EntriesList.vue?vue&type=style&index=0&id=c8162cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8162cfc",
  null
  
)

export default component.exports